import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, Comment } from './index';

export interface CommentByIdGetParams {
  id: string;
}

export const commentById = (payload: CommentByIdGetParams): Action<CommentByIdGetParams> => ({
  type: actions.commentByIdTrigger.toString(),
  payload,
});

export const commentByIdClear = (): Action => ({
  type: actions.commentByIdClear.toString(),
});

export const commentByIdErrorClear = (): Action => ({
  type: actions.commentByIdErrorReset.toString(),
});

export function* commentByIdRequestSaga({ payload }: Action<CommentByIdGetParams>) {
  yield put({
    type: actions.commentByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.commentByIdError.toString(),
      payload: {
        message: 'CommentById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}comments/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Comment, Comment>(
    response,
    actions.commentByIdSuccess.toString(),
    actions.commentByIdError.toString(),
    false,
    (commentByIdData) => commentByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.commentByIdTrigger.toString(),
    defaultProcessingSaga(
      commentByIdRequestSaga,
      {
        error: actions.commentByIdError.toString(),
        locationCancel: actions.commentByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.commentByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.commentByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.commentByIdErrorReset.toString(),
    });
  });
}
